"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripCjkSegmentBreaks = exports.normalizeComponentWhitespace = exports.componentsDeserializer = exports.componentsSerializer = exports.deserializeLegacyHtmlToComponents = exports.deserializeHtmlToComponents = exports.serializeComponentsToHtml = exports.isValidHtmlContent = exports.serialize = exports.deserializerHandle = exports.deserialize = void 0;
const cheerio_1 = __importDefault(require("cheerio"));
const legacy_1 = require("./legacy");
const common_utils_1 = require("./utils/common-utils");
const segment_breaks_1 = require("./utils/segment-breaks");
const components_map_1 = require("./components-map");
const isRunningInBrowser = () => typeof window !== 'undefined' && !!window.document;
// Callers may inject their own jQuery-like parser ($); otherwise deserialize uses
// a bundled cheerio root so the common case is deserialize(html, locale).
let bundledParser;
const getDefaultParser = () => {
    if (!bundledParser) {
        bundledParser = cheerio_1.default.load('');
    }
    return bundledParser;
};
const deserialize = (html, locale, parser = getDefaultParser()) => {
    const inputHtml = isRunningInBrowser() ? html : (0, common_utils_1.fixNonSelfClosingIframes)(html);
    return (0, exports.deserializerHandle)(parser)(inputHtml, locale);
};
exports.deserialize = deserialize;
const deserializerHandle = ($) => (html, locale) => ((0, exports.isValidHtmlContent)($)(html, locale)
    ? (0, exports.deserializeHtmlToComponents)($)(html, locale)
    : (0, exports.deserializeLegacyHtmlToComponents)($)(html, locale)).map((component) => (0, segment_breaks_1.normalizeComponentWhitespace)(component));
exports.deserializerHandle = deserializerHandle;
const serialize = (components) => (0, exports.serializeComponentsToHtml)(components);
exports.serialize = serialize;
const isValidHtmlContent = ($) => (html, locale) => {
    try {
        const parsedComponents = (0, exports.deserializeHtmlToComponents)($)(html, locale);
        const reversedHtml = (0, exports.serializeComponentsToHtml)(parsedComponents);
        const doubleParsedComponents = (0, exports.deserializeHtmlToComponents)($)(reversedHtml, locale);
        const $children = $('<div>').html(html).children();
        const componentCount = $children.filter('div[data-component-type]').length;
        const childrenCount = $children.length;
        const childrenCountMatch = childrenCount === parsedComponents.length;
        const componentCountMatch = componentCount === parsedComponents.length;
        const hasComponents = componentCount > 0;
        const componentContentMatch = (0, common_utils_1.deepEquals)(parsedComponents, doubleParsedComponents);
        return hasComponents && childrenCountMatch && componentCountMatch && componentContentMatch;
    }
    catch (_a) {
        return false;
    }
};
exports.isValidHtmlContent = isValidHtmlContent;
const serializeComponentsToHtml = (components) => components
    .map((component) => {
    const type = (0, common_utils_1.normalizeType)(component.type);
    const innerValue = components_map_1.componentsSerializer[type](component.value);
    return `<div data-component-type="${type}">${innerValue}</div>`;
})
    .join('');
exports.serializeComponentsToHtml = serializeComponentsToHtml;
const deserializeHtmlToComponents = ($) => (html, locale) => $(html)
    .filter('div[data-component-type]')
    .toArray()
    .map((node) => {
    const $node = $(node);
    const templateId = $node.attr('data-template-id');
    const templatePartIndexString = $node.attr('data-template-part-index');
    const type = (0, common_utils_1.normalizeType)($node.attr('data-component-type'));
    const value = (0, components_map_1.componentsDeserializer)($, locale)[type]($node.contents());
    const componentData = { type, value };
    if (templateId) {
        componentData.template = {
            id: templateId,
            index: parseInt(templatePartIndexString, 10),
        };
    }
    return componentData;
});
exports.deserializeHtmlToComponents = deserializeHtmlToComponents;
const deserializeLegacyHtmlToComponents = ($) => (legacyHtml, locale) => (0, legacy_1.legacyDeserializerHandle)($)(legacyHtml, locale);
exports.deserializeLegacyHtmlToComponents = deserializeLegacyHtmlToComponents;
var components_map_2 = require("./components-map");
Object.defineProperty(exports, "componentsSerializer", { enumerable: true, get: function () { return components_map_2.componentsSerializer; } });
Object.defineProperty(exports, "componentsDeserializer", { enumerable: true, get: function () { return components_map_2.componentsDeserializer; } });
var segment_breaks_2 = require("./utils/segment-breaks");
Object.defineProperty(exports, "normalizeComponentWhitespace", { enumerable: true, get: function () { return segment_breaks_2.normalizeComponentWhitespace; } });
Object.defineProperty(exports, "stripCjkSegmentBreaks", { enumerable: true, get: function () { return segment_breaks_2.stripCjkSegmentBreaks; } });
